
























import { Component, Prop } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import { CheckIcon, CopyIcon, PlusIcon } from 'vue-feather-icons';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { GoalCurrentValueModel } from 'admiral-core';

@Component({
  components: {
    FormDateInput,
    FormTextarea,
    FormError,
    FormInput,
    FormRow,
    PlusIcon,
    CopyIcon,
    CheckIcon,
  },
})
export default class GoalCustomValueForm extends mixins(BaseMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: GoalCurrentValueModel;

  @Prop({ required: true, type: Object })
  readonly errors!: GoalCurrentValueModel;

  async mounted() {
    //
  }

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }
}
